import { Capacitor } from '@capacitor/core';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { firebaseConfig } from '../../firebase.config';
import { PushNotifications } from '@capacitor/push-notifications';

export function initializePushNotifications() {
    isSupported().then((supported) => {
        if (supported && Capacitor.getPlatform() === 'web' && !Capacitor.isNativePlatform()) {
            navigator.serviceWorker.register('/firebase-messaging-sw.js')
                .then((registration) => {
                    console.log('ServiceWorker registration successful with scope: ', registration.scope);
                    _requestPermission();
                    _listen();
                });
        }
    });

    if (Capacitor.isNativePlatform()) {
        _registerPush();
    }
}

// Desktop Push Notifications
function _requestPermission() {
    const messaging = getMessaging();
    getToken(messaging,
             {vapidKey: firebaseConfig.vapidKey}).then(
        (currentToken) => {
            console.log('currentWebToken', currentToken);
            if (currentToken) {
                _checkFirebaseToken(currentToken);
            } else {
                console.log('No registration token available. Request permission to generate one.');
            }
        }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
}

function _listen() {
    const messaging = getMessaging();
    onMessage(messaging, (message ) => {
    console.log('Message received. ', message);

    // Show toast notification when in app
    /*void Swal.fire({
        ...notificationSwalOptions,
        title: message.notification.title,
        text: message.notification.body,
    });*/
});
}

function _checkFirebaseToken(token) {
    http.post('/api/firebase-token', {fcm_token: token})
        .then((response) => {
            console.log('Firebase token sent to server');
        })
        .catch((error) => {
            console.log('Firebase token sending failed', error);
        });
}

// Capacitor Push Notifications
function _registerPush() {
    PushNotifications.requestPermissions().then(result => {
        console.log('PushNotifications.requestPermissions', result);
        if (result.receive === 'granted') {
            PushNotifications.register()
                .then((res) => { console.log(res); },
                    (err) => { console.log(err); });
        } else {
            console.log('User denied permissions');
        }
    });

    void PushNotifications.addListener('registration', (token) => {
        console.log('capacitor token', token.value);
        _checkFirebaseToken(token.value);
    });

    void PushNotifications.addListener('registrationError', (err) => {
        console.log('Registration error: ', err.error);
    });

    void PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('Push notification received: ', notification);
    });

    void PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        console.log('Push notification clicked', notification.actionId, notification.inputValue);
    });
}
